import axios from '@/libs/api.request'
// 登录
export const login = data => {
  return axios.request({
    url: '/login',
    data,
    method: 'POST'
  })
}
// 退出
export const logout = data => {
  return axios.request({
    url: '/logout',
    data,
    method: 'POST'
  })
}
// 忘记密码 -发送验证码
export const codeReset = data => {
  return axios.request({
    url: '/code/send',
    data,
    method: 'POST'
  })
}
// 忘记密码 -校验验证码
export const codeCheck = data => {
  return axios.request({
    url: '/code/verify',
    data,
    method: 'POST'
  })
}
// 忘记密码 - 重置密码
export const passReset = data => {
  return axios.request({
    url: '/reset',
    data,
    method: 'POST'
  })
}
